import script from "./CRMDatatableTDTaskType.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMDatatableTDTaskType.vue?vue&type=script&setup=true&lang=js"

import "./CRMDatatableTDTaskType.vue?vue&type=style&index=0&id=d9290856&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9290856"]])

export default __exports__